import { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Alert
} from '@mui/material';
import dayjs from 'dayjs';
import { scheduleAppointment } from '../../../services/appointments';
import { getPanelRole } from '../../../services/api';

const ScheduleConsultationDialog = ({ open, onClose, patient, onScheduled }) => {
    const [dateTime, setDateTime] = useState(dayjs().format('YYYY-MM-DDTHH:mm'));
    const [duration, setDuration] = useState(30);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const roleUUID = getPanelRole();

    const handleSchedule = async () => {
        setSaving(true);
        setError('');
        try {
            await scheduleAppointment({
                patient: patient.role_uuid,
                doctor: roleUUID,
                ts: dayjs(dateTime).toISOString(),
                slot_duration: Number(duration)
            });

            onScheduled?.();
            onClose();
        } catch (err) {
            console.error('Erro ao agendar consulta', err);
            setError(
                'Não foi possível confirmar o agendamento. Verifique as consultas antes de tentar novamente.'
            );
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={saving ? undefined : onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Agendar Consulta</DialogTitle>

            <DialogContent>
                {error && <Alert severity="error">{error}</Alert>}
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Data e Hora"
                            value={dateTime}
                            disabled={saving}
                            onChange={(e) => setDateTime(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Duração (minutos)"
                            value={duration}
                            disabled={saving}
                            inputProps={{ min: 1, step: 1 }}
                            onChange={(e) => setDuration(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose} disabled={saving}>
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSchedule}
                    disabled={
                        saving ||
                        !dayjs(dateTime).isValid() ||
                        !Number.isInteger(Number(duration)) ||
                        Number(duration) <= 0
                    }
                >
                    Agendar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ScheduleConsultationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    patient: PropTypes.shape({ role_uuid: PropTypes.string }).isRequired,
    onScheduled: PropTypes.func
};

export default ScheduleConsultationDialog;
